import React, { useState } from "react";
import Common_Back_Btn from "../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Instrument_Report_Filter from "./instrument_report_filter/Instrument_Report_Filter";
import Instrument_Report_Table from "./instrument_report_table/Instrument_Report_Table";
import Common_Report_Offcanvas from "../../common_report_offcanvas/Common_Report_Offcanvas";
import { useDispatch, useSelector } from "react-redux";
import {
  GetInstrumantReport,
  GetSampleReport,
} from "../../../../../features/admin/report_generator/Slice";
import { FixIDS } from "../../../../../utils/fixIDS";

const Instrument_Report = () => {

  const permissions = useSelector((state) => state.auth.permissions);
  const haveReportPermission = permissions?.includes(FixIDS.instrument_report.Report);


  const [show, setShow] = useState(false);
  const [searchParams, setSearchParams] = useState({
    createdAt:"",
    unique_id: "",
    instrument_name: "",
    calibration_status_id: "",
    calibrated_id: "",
    end_date: "",
    start_date: "",
    year: ""
  });

  const dispatch = useDispatch();
  const [showLottie, setShowLottie] = useState(true);
  const [reportPath, setReportPath] = useState("");
  const reportgenerate = async () => {
    setShow(true);
    setShowLottie(true);
    const response = await dispatch(
      GetInstrumantReport({
        createdAt: searchParams.createdAt || "",
        unique_id: searchParams.unique_id || "",
        instrument_name: searchParams.instrument_name || "",
        calibration_status_id: searchParams.calibration_status_id || "",
        calibrated_id: searchParams.calibrated_id || "",
        start_date: searchParams.start_date || "",
        end_date: searchParams.end_date || "",
        name: searchParams,
        page: 1,
        per_page: 10,
      }),
    );

    if (response?.meta?.requestStatus === "fulfilled") {
      const path = response?.payload?.path;
      setReportPath(path);
      setShowLottie(false);
    } else {
      setShowLottie(false); // also stop loader on error
    }
  };
  return (
    <section className="Sample_Report Instrument_Report">
      <div className="back_div">
        <Common_Back_Btn backText="Instrument Report" />
      </div>

      <div className="Sample_Report_Filter_div">
        <Instrument_Report_Filter
          setShow={setShow}
          setSearchName={setSearchParams}
          reportgenerate={reportgenerate}
        />
      </div>

      <div className="report_table_div">
        { haveReportPermission && <Instrument_Report_Table searchName={searchParams} />}
      </div>

      <Common_Report_Offcanvas
        reportPath={reportPath}
        reportgenerate={reportgenerate}
        setShowLottie={setShowLottie}
        showLottie={showLottie}
        title={"Instrument Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default Instrument_Report;
